import { useCallback } from 'react'
import { FormattedDate } from 'react-intl'
import { Box, CardMedia, styled } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import { BlogPost } from 'features/home/types'

const Root = styled(Box)(({ theme }) => ({
  cursor: 'pointer',

  '&:hover': {
    '& img': {
      boxShadow: theme.shadows[8]
    },
    '& .MuiTypography-subtitle1': {
      color: theme.palette.primary.main
    }
  }
}))

const HeaderImg = styled(CardMedia)(({ theme }) => ({
  objectPosition: 'left',
  height: theme.spacing(28),
  borderRadius: theme.spacing(0.5),

  transition: theme.transitions.create('box-shadow', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.standard
  }),

  [theme.breakpoints.between('md', 'lg')]: {
    height: theme.spacing(32)
  }
})) as typeof CardMedia

const InfoWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),

  [theme.breakpoints.up('xl')]: {
    marginTop: theme.spacing(3)
  }
}))

const BlogDate = styled(Typography)(() => ({
  textTransform: 'uppercase'
}))

const Title = styled(Typography)(({ theme }) => ({
  transition: theme.transitions.create('color', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.standard
  })
}))

function HomeBlogCard({ post }: { post: BlogPost }) {
  const onClick = useCallback(() => {
    window.open(post.url, '_blank', 'noopener,noreferrer')
  }, [post.url])

  const date = new Date(post.created_at * 1000)

  return (
    <Root onClick={onClick}>
      <HeaderImg image={post.img} title={post.title} component="img" />
      <InfoWrapper>
        <BlogDate noWrap variant="overline" color="textSecondary">
          <FormattedDate value={date} year="numeric" month="short" day="numeric" />
        </BlogDate>
        <Title variant="subtitle1" component="h4">
          {post.title}
        </Title>
      </InfoWrapper>
    </Root>
  )
}

export default HomeBlogCard
